export const getTransactionFee = async (client, { baseUrl }, { txId }) => {
    const apiUrl = `${baseUrl}/tx/${txId}`;
    const response = (await client.request({
        url: apiUrl,
        fetchOptions: { method: 'GET' },
    }));
    return {
        result: BigInt(response.fee),
    };
};
//# sourceMappingURL=getTransactionFee.js.map